import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import moment from 'moment'
import _ from 'lodash'
import getLabel from '../../utilities/label.js'
import TitleBar from '../TitleBar'

export default class Evaluations extends Component {
  constructor(props) {
    super(props)
    const refreshButton = '<i class=\'fa fa-refresh\'></i>'
    const backButton = '<i class=\'fa fa-arrow-left\'></i> ' + getLabel('back_button')
    this.refresh = this.refresh.bind(this)
    this.state = {
      events: this.props.events,
      refreshButton: refreshButton,
      backButton: backButton
    }
    this.props.setActiveTab('evaluations')
    window.trackPage('EvaluationsScreen')
  }

  refresh() {
    const refreshButton = '<i class=\'fa fa-refresh fa-spin\'></i>'
    this.setState({ refreshButton: refreshButton })
    this.props.getResource({
      key: 'sessions',
      update: true,
      callback: () => {
        this.setState({
          refreshButton: '<i class=\'fa fa-refresh\'></i>'
        })
      }
    })
  }

  getEventEvaluations() {
    const surveys = []
    const currentEvent = _.find(this.props.events.events, (event) => {
      if(event.id === window.currentUser.current_event_id){
        return event
      }
    })
    if(currentEvent) {
      if(currentEvent.event_surveys) {
        _.each(currentEvent.event_surveys, (event_survey) => {
          if(!event_survey.is_taken){
            surveys.push(
              <Link to={'/event_evaluation/' + event_survey.id} className="event-eval-link" key="event_survey-{event_survey.id}">
                <div className='session-time'>{getLabel('eval_general')} </div>
                <div className='event-eval-name'>{event_survey.name}</div>
                <div className='session-room'>{getLabel('eval_overall')} </div>
              </Link>
            )
          } else {
            surveys.push(
              <div className='simple-session' key="session_eval_complete-{event_survey.id}">
                <div className='session-time'>{getLabel('eval_general')} </div>
                <div className='event-eval-name taken-text'>{event_survey.name}<i className='float-right fa fa-check-circle taken-icon'></i></div>
                <div className='session-room'>{getLabel('eval_overall')} </div>
              </div>
            )
          }
        })
      }
    }
    if (surveys.length) {
      return (
        <div>
          <div className='gray-header'>Event Evaluations</div>
          <div className='container'>
            { surveys }
          </div>
        </div>
      )
    }
  }

  matchingTimeSlot(session) {
    if(session.evaluation_completed){
      let filterFunction = (relatedSessions) => relatedSessions.formatted_display_date === session.formatted_display_date && !relatedSessions.evaluation_completed
      let sessionsInTimeBlock = this.props.sessions.sessions.filter(filterFunction)
      _.each(sessionsInTimeBlock, (matchingSession) => {
        matchingSession.evaluation_taken_in_timeblock = true
      })
    }
  }

  takeToEval(session) {
    if(!session.evaluation_completed) {
      // adjusted time here, because browser epoch time is 3 orders of magnitude greater than what we pass down from API
      let adjustedCurrentTime = (Date.now()/1000)

      // if session start time greater than current -- do not allow user to access evaluation
      if (adjustedCurrentTime < session.epoch_start_time) {
        this.props.flashMessage({
          message: getLabel('session_has_not_started'),
          type: 'error'
        })
      } else {
        this.props.history.push('/session_evaluation/' + session.id + '/evaluations')
      }
    }
  }

  takeToOneOnOneEval(one_on_one_meeting) {
    if(!one_on_one_meeting.evaluation_completed) {
      if ((Date.now()/1000) < one_on_one_meeting.epoch_start_time) {
        this.props.flashMessage({
          message: getLabel('session_has_not_started'),
          type: 'error'
        })
      } else {
        this.props.history.push('/one_on_one_session_evaluation/' + one_on_one_meeting.event_session_id + '/one_on_one_meeting_id/' + one_on_one_meeting.id)
      }
    }
  }

  participantOrHidden(participantUser) {
    const users = JSON.parse(localStorage.getItem('users')).event_users
    var otherUser = users?.find((user) => {
      return user?.user_id === participantUser?.id
    })
    return otherUser ? `${otherUser.first_name} ${otherUser.last_name}, ${otherUser.organization_name}` : 'User hidden'
  }

  oneOnOneRows(activeOneOnOneMeetings) {
    let oneOnOneMeetings = []
    activeOneOnOneMeetings.map((oneOnOneMeeting) => {
      let user = oneOnOneMeeting.participant_user
      if (oneOnOneMeeting.id) {
        if (oneOnOneMeeting.evaluation_completed) {
          oneOnOneMeetings.push(
            <div key={oneOnOneMeeting.id}>
              <div className="session-time">{oneOnOneMeeting.formatted_display_date}</div>
              <div><i className="float-right fa fa-check-circle taken-icon"></i></div>
              <div className="session-name taken-text">{this.participantOrHidden(user)}</div>
              <hr />
            </div>
          )
        } else {
          oneOnOneMeetings.push(
            <div key={oneOnOneMeeting.id}>
              <a onClick={() => this.takeToOneOnOneEval(oneOnOneMeeting)}>
                <div className="session-time">{oneOnOneMeeting.formatted_display_date}</div>
                <div className="session-name">{this.participantOrHidden(user)}</div>
              </a>
              <hr />
            </div>
          )
        }
      }
    })
    return oneOnOneMeetings
  }

  getOneOnOneSessionEvaluations() {
    let oneOnOneSessions = this.props.sessions.sessions.filter((session) => {
      return session.session_type_key === 'session_type_one_to_one_meeting'
    })
    let activeOneOnOneMeetings = []
    oneOnOneSessions.forEach((oneOnOneSession) => {
      if (oneOnOneSession?.id) {
        let meeting = oneOnOneSession.one_on_one_meetings.filter((oneOnOneMeeting) => {
          return oneOnOneMeeting.id != null
        })
        activeOneOnOneMeetings.push(meeting)
      }
    })
    activeOneOnOneMeetings = activeOneOnOneMeetings.flat()
    if (activeOneOnOneMeetings.length > 0) {
      return (
        <div>
          <div className="gray-header">Peer-to-Peer Evaluations</div>
          <div className='container'>
            {this.oneOnOneRows(
              _.sortBy(activeOneOnOneMeetings, function(meeting) {
                return meeting.epoch_start_time
              })
            )}
          </div>
        </div>
      )
    }
  }

  getSessionEvaluations() {
    if(window.currentUser.can_take_session_survey) {
      const surveys = []
      var now = moment().format() // This may need some timezone awareness.
      this.props.sessions.sessions.filter(s => s.session_type_key !== 'session_type_one_to_one_meeting').forEach((session) => {
        this.matchingTimeSlot(session)
        if(!session.evaluation_completed && session.evaluation_taken_in_timeblock || session.registration_status === 'not_authorized' || session.session_type_key === 'session_type_one_to_one_meeting'){
          surveys.push(
            <div className="hide" key={session.id}></div>
          )
        } else if(!session.itinerary && !session.is_hidden) {
          if(!session.evaluation_completed) {
            var red = null
            if(session.day_end_stamp < now &&
              (session.registration_status === 'un_register')) {
              red = 'red'
            }
            surveys.push(
              <div key={session.id}>
                <a onClick={() => this.takeToEval(session)}>
                  <div className='simple-session'>
                    <div className='session-time'>{ session.formatted_display_date }</div>
                    <div className={ 'session-name ' + red }>{session.name} </div>
                    <div className='session-room'>{session.room_name} -- {session.session_type}</div>
                  </div>
                </a>
                <hr />
              </div>
            )
          } else {
            surveys.push(
              <div className='simple-session' key={session.id}>
                <div className='session-time'>{ session.formatted_display_date }</div>
                <div className='session-name taken-text'>{session.name}<i className='float-right fa fa-check-circle taken-icon'></i></div>
                <div className='session-room'>{session.room_name} - {session.session_type}</div>
                <hr />
              </div>
            )
          }
        }
      })

      if (surveys.length) {
        return (
          <div>
            <div className='gray-header'>Session Evaluations</div>
            <div className='container'>
              { surveys }
            </div>
          </div>
        )
      }
    }
  }

  hasEvaluations() {
    const currentEvent = _.find(this.props.events.events, (event) => {
      if(event.id === window.currentUser.current_event_id){
        return event
      }
    })
    const hasEventEvaluation = currentEvent.event_surveys.length > 0
    const hasSessionEvaluations = _.some(this.props.sessions.sessions, (session) => {
      return !session.itinerary && !session.is_hidden
    })
    return hasEventEvaluation || (hasSessionEvaluations && window.currentUser.can_take_session_survey)
  }

  render() {
    return (
      <div>
        <TitleBar
          title="Evaluations"
          leftButtonLabel={ this.state.backButton }
          leftButtonAction={ () => window.history.back() }
          rightButtonLabel={ this.state.refreshButton }
          rightButtonAction={ this.refresh } />
        { this.hasEvaluations() ?
          <div className='eval-list-page'>
            { this.getEventEvaluations() }
            { this.getSessionEvaluations() }
            { this.getOneOnOneSessionEvaluations() }
          </div> :
          <div style={{ textAlign: 'center'}}>{ getLabel('no_results_found') }</div>
        }
      </div>
    )
  }
}
